import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UpdateMetricsService {
  
  private emitChange = new Subject<void>();
  
  change$ = this.emitChange.asObservable();

  notify() {
    this.emitChange.next();
  }
}